import { render, staticRenderFns } from "./TelegramChannelConnectionViewOnboarding.vue?vue&type=template&id=0ab15b44&scoped=true"
import script from "./TelegramChannelConnectionViewOnboarding.vue?vue&type=script&lang=js"
export * from "./TelegramChannelConnectionViewOnboarding.vue?vue&type=script&lang=js"
import style0 from "./TelegramChannelConnectionViewOnboarding.vue?vue&type=style&index=0&id=0ab15b44&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab15b44",
  null
  
)

export default component.exports